import Component from '@averyano/core/src/classes/Component';

import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
GSAP.registerPlugin(ScrollTrigger);

import each from 'lodash/each';

export default class CoverSection extends Component {
	constructor() {
		super({
			element: '.cover',
			elements: {
				brushMaskRect: '.mask-rect',
			},
		});
	}

	create() {
		super.createComponent();

		this.createTimeline();
	}

	createTimeline() {
		console.log('Making ');
		// this.timeline = GSAP.timeline();
		// this.timeline.to(this.elements.brushMaskRect, {
		// 	duration: 1.5,
		// 	ease: 'power2.out',
		// 	scaleX: 1,
		// });
		console.log(this.elements.brushMaskRect);
	}

	clearTimeline() {}

	show() {}

	destroy() {
		super.destroy();
		// this.clearTimeline();
	}
}
